import { render, staticRenderFns } from "./ElectionsOwnerOccupied.vue?vue&type=template&id=734224f7&scoped=true"
import script from "./ElectionsOwnerOccupied.vue?vue&type=script&lang=js"
export * from "./ElectionsOwnerOccupied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734224f7",
  null
  
)

export default component.exports